import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import { Outlet } from "react-router-dom";

const MasterLayout = () => {
  return (
    <>
      <Header />
      <div className="App">
        <div className="absolute inset-0">
          <Outlet />
          <Footer />
        </div>
      </div>
    </>
  );
};

export default MasterLayout;
